import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./Customers.css";

const customerLogos = [
  { id: 1, name: "Maritime Partner", logo: "/images/client-1.jpg" },
  { id: 2, name: "ANA Marine Agencies", logo: "/images/client-2.jpg" },
  { id: 3, name: "MSC Shipping", logo: "/images/client-3.jpg" },
  { id: 4, name: "Servocean", logo: "/images/logo.webp" },
  { id: 5, name: "Marine One", logo: "/images/client-5.jpg" },
  { id: 6, name: "Synergy Group", logo: "/images/client-6.jpg" },
  { id: 7, name: "ILM Shipping", logo: "/images/client-7.jpg" },
  { id: 8, name: "Prudential Shipping", logo: "/images/images-8.png" },
  { id: 9, name: "Hapag-Lloyd", logo: "/images/images-9.png" },
  { id: 10, name: "Marine One", logo: "/images/images-10.jpg" },
  { id: 11, name: "Holger Navigation", logo: "/images/client-11.jpg" },
  { id: 12, name: "Skyships Services", logo: "/images/client-12.png" },
  { id: 13, name: "Reederei NSB", logo: "/images/client-13.png" },
  { id: 14, name: "MAN PrimeServ", logo: "/images/client-14.png" },
  { id: 15, name: "Colombo Dockyard PLC", logo: "/images/client-15.jpg" },
  { id: 16, name: "Shipping Corp of India (SCI)", logo: "/images/client-4.png" },
  { id: 17, name: "AGME Maritime", logo: "/images/agme.webp" },
  { id: 18, name: "Centrum Marine", logo: "/images/centrum.webp" },
  { id: 19, name: "Menzell Döhle", logo: "/images/menzell.webp" },
  { id: 20, name: "Technomar Crew Management", logo: "/images/tcmc_logo.webp" },
  { id: 21, name: "Kanoo Shipping", logo: "/images/kanoo-shipping-logo-001.webp" },
  { id: 22, name: "Specialised Shipping Services", logo: "/images/specialised-shipping-services-logo.webp" },
  { id: 23, name: "V.Ships", logo: "/images/V.ship_logo_green.webp" },
];

const Customers = () => {
  return (
    <section className="customers-section" id="customers">
      <div className="customers-header">
        <span className="customers-badge">Trusted Partners</span>
        <h2 className="customers-title">Our Valued Clients</h2>
        <p className="customers-subtitle">
          Proudly serving world-class ship owners, operators, and maritime agencies across South Asia and international waters.
        </p>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={26}
        slidesPerView={5}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 14 },
          480: { slidesPerView: 2.2, spaceBetween: 16 },
          640: { slidesPerView: 3, spaceBetween: 18 },
          768: { slidesPerView: 3.2, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1280: { slidesPerView: 5, spaceBetween: 26 },
          1600: { slidesPerView: 5, spaceBetween: 28 },
        }}
        className="customers-swiper"
      >
        {customerLogos.map((customer) => (
          <SwiperSlide key={customer.id}>
            <div className="customer-card" title={customer.name}>
              <div className="customer-logo-wrapper">
                <img
                  src={customer.logo}
                  alt={customer.name}
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
              <span className="customer-name">{customer.name}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Customers;
